/* eslint-disable @next/next/no-img-element */
import React from "react";
import { trendingCategoryData } from "../../data/categories_data";
import { HeadLine } from "../component";
import Trending_categories_items from "./trending_categories_items";

const Trending_category = () => {
  return (
    <section className="py-24">
      <div className="container">
        <HeadLine
          text="All Projects"
          classes="font-display text-jacarta-700 mb-8 text-center text-3xl dark:text-white"
        />

        {/* trending categories */}
          <Trending_categories_items />
      </div>
    </section>
  );
};

export default Trending_category;
